import React from "react";
import { Icon } from "@iconify/react";

// QR counters cumulative hain (date-wise nahi), isliye
// "previous period" comparison yahan nahi dikhaya.
const UnitCountQr = ({ total_qr_scans = 0, positive = 0, negative = 0 }) => {
  return (
    <div className="col-xxl-3 col-sm-6">
      {/* h-100 hata diya: card ab sirf apni content ki height lega */}
      <div className="card px-24 py-16 shadow-none radius-8 border bg-gradient-start-1">
        <div className="card-body p-0">
          <div className="d-flex align-items-center gap-2 mb-12">
            <span className="w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
              <Icon icon="mdi:qrcode-scan" className="icon" />
            </span>
            <div>
              <span className="fw-medium text-secondary-light text-sm">
                Total QR Scans
              </span>
              <h6 className="fw-semibold mb-0">{total_qr_scans}</h6>
            </div>
          </div>

          <p className="text-sm mb-0 d-flex flex-wrap gap-2">
            <span className="text-success-main">{positive} Positive</span>
            <span className="text-secondary-light">·</span>
            <span className="text-danger-main">{negative} Negative</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnitCountQr;
